import { lazy } from 'react';

/**
 * Lazily-loaded TanStack Router devtools (development only).
 *
 * Lives in its own module so `router.tsx` exports only non-component values
 * (the router instance and types). eslint-plugin-react-refresh's
 * `only-export-components` rule flags a component declared alongside
 * non-component exports, which would break Fast Refresh. See shipcast-7i0.
 */
export const TanStackRouterDevtools = import.meta.env.DEV
  ? lazy(() =>
      import('@tanstack/react-router-devtools').then((res) => ({
        default: res.TanStackRouterDevtools,
      })),
    )
  : () => null;
